<script>
  /**
   * One row of the "Detailed Feedback" section, shared by the reading,
   * listening, writing and speaking IELTS reports so that every skill numbers
   * its exercises the same way and shows its result in the same place.
   *
   * Left:  "<counter>. <exercise name>", counter starting at 1 per report.
   * Right: the result badge (band or raw score) at a fixed width, followed by
   *        the collapse chevron — so the badge never shifts between items.
   */
  export let number;
  export let title;
  // Displayed result, e.g. "6.5" or "8 / 10". Null renders the placeholder.
  export let value = null;
  // Badge caption, e.g. the translated "Band" or "Score".
  export let label = "";
  // Shown under the badge when there is no result, e.g. "Not answered".
  export let emptyText = "-";
  export let collapsed = false;
  export let toggle = () => {};
</script>

<button type="button" class="item-header" on:click={toggle}>
  <span class="item-title">
    <span class="item-number">{number}.</span>
    {title}
  </span>

  <span class="item-result">
    <span class="item-result-label">{label}</span>
    <span class="item-result-value" class:empty={value === null}>
      {value === null ? emptyText : value}
    </span>
  </span>

  <i class="fas item-chevron {collapsed ? 'fa-chevron-down' : 'fa-chevron-up'}" />
</button>

<style>
  .item-header {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid #e5e7eb;
    cursor: pointer;
    text-align: left;
  }

  .item-header:focus {
    outline: none;
  }

  .item-title {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 1.15rem;
    font-weight: 700;
    color: #374151;
  }

  .item-number {
    color: #6b7280;
    margin-right: 0.35rem;
  }

  .item-result {
    flex: 0 0 8rem;
    width: 8rem;
    text-align: center;
    line-height: 1.1;
  }

  .item-result-label {
    display: block;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #6b7280;
  }

  .item-result-value {
    display: block;
    font-size: 2rem;
    font-weight: 700;
    color: #0056b3;
  }

  .item-result-value.empty {
    font-size: 1rem;
    font-weight: 600;
    color: #9ca3af;
  }

  .item-chevron {
    flex: 0 0 auto;
    color: #6b7280;
  }

  @media (max-width: 768px) {
    .item-title {
      font-size: 1rem;
    }

    .item-result {
      flex: 0 0 6rem;
      width: 6rem;
    }

    .item-result-value {
      font-size: 1.6rem;
    }
  }
</style>
